import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { CommonStyles } from '../../../common/react/CommonStyles';
import { ISiteUserInfo } from '../../../ts/models/ISiteUserInfo';
import { DataGridProfilePicture } from '../../content/DataGridProfilePicture';
import { ProfilePictureStyles } from '../../content/styles/ProfilePictureStyles';
import { getLinkMarkup, ILink } from '../ListView/dataGridCells/LinkCell';
import { PlainTextCellWithIcon } from '../ListView/dataGridCells/PlainTextAndNumberCells';
import { StyledCellFormatter } from '../ListView/StyledCellWrapper';
import { SiteUserAuthenticationProviderContext } from './UserAuthenticationProviderContext';

export namespace UserDataGridCells {

  export function ProfilePictureCell(
      getProfileProps: (row: DataGrid.Row) => DataGridProfilePicture.Props,
      getLinkOptions: (row: DataGrid.Row) => ILink
    ): React.StatelessComponent<BodyCell.Props> {
    return StyledCellFormatter(function ProfilePictureCells(props: BodyCell.Props) {
      const linkOptions = getLinkOptions(props.row);
      return (
        <div style={ProfilePictureStyles.Layout.UserNameWithProfilePictureCellWrapperStyle}>
          <span style={ProfilePictureStyles.Layout.UserNameWithProfilePictureCellChildStyle}>
            <DataGridProfilePicture {...getProfileProps(props.row)} />
          </span>
          <span style={ProfilePictureStyles.Layout.UserNameWithProfilePictureCellChildDisplayNameStyle}>
            <span data-tb-test-id={linkOptions.testId} style={CommonStyles.Layout.FlexBlockLeftAndCenter}>
              {getLinkMarkup(linkOptions, props.row)}
            </span>
          </span>
        </div>
      );
    });
  }

  export function AuthenticationProviderConsumerHOC(Component: any): React.StatelessComponent<BodyCell.Props> {
    return (props: BodyCell.Props) =>
      <SiteUserAuthenticationProviderContext.Consumer>
        {provider => Component({getUserAuthenticationInfo: provider})(props)}
      </SiteUserAuthenticationProviderContext.Consumer>;
  }

  export interface AuthenticationProps {
    readonly getUserAuthenticationInfo: (user: ISiteUserInfo) => {name: string, isEnabled: boolean};
  }
  export function AuthenticationProviderConsumer(authProps: AuthenticationProps) {
    return function AuthenticationProviderConsumer(props: BodyCell.Props) {
      const metadata = authProps.getUserAuthenticationInfo(props.row.data as ISiteUserInfo);
      return PlainTextCellWithIcon((row: any) => {
        return {
          text: metadata.name,
          iconClass: metadata.isEnabled ? null : 'tb-icon-alert-list-header tb-react-dg-hcol',
          iconTitle: Messages.disabled()
        };
      })(props);
    };
  }

  export const AuthenticationCell = AuthenticationProviderConsumerHOC(AuthenticationProviderConsumer);
}
